import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';

import ErrorMessage from 'login-components/Common/Notifications/ErrorMessage/ErrorMessage';

export interface LogoutDialogProps {
  errorMessage: string;
}

const styles = StyleSheet.create({
  notificationWrapper: {
    marginBottom: 20,
  },
});

class LogoutDialog extends React.Component<LogoutDialogProps, {}> {
  render() {
    const { errorMessage } = this.props;

    return (
      <div className={css(styles.notificationWrapper)}>{errorMessage && <ErrorMessage errorText={errorMessage} />}</div>
    );
  }
}

export default LogoutDialog;
